// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`when no validation errors happened renders and matches snapshot 1`] = `
<body>
  <div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <div
        class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
      >
        <label
          class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
          data-shrink="true"
          for="first-name"
          id="first-name-label"
        >
          First name
          <span
            aria-hidden="true"
            class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
          >
             
            *
          </span>
        </label>
        <div
          class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
        >
          <input
            aria-invalid="false"
            class="MuiInputBase-input MuiOutlinedInput-input"
            id="first-name"
            required=""
            type="text"
            value="Test first"
          />
          <fieldset
            aria-hidden="true"
            class="PrivateNotchedOutline-root-3 MuiOutlinedInput-notchedOutline"
          >
            <legend
              class="PrivateNotchedOutline-legendLabelled-5 PrivateNotchedOutline-legendNotched-6"
            >
              <span>
                First name
                 *
              </span>
            </legend>
          </fieldset>
        </div>
        
      </div>
    </div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <div
        class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
      >
        <label
          class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
          data-shrink="true"
          for="last-name"
          id="last-name-label"
        >
          Last name
          <span
            aria-hidden="true"
            class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
          >
             
            *
          </span>
        </label>
        <div
          class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
        >
          <input
            aria-invalid="false"
            class="MuiInputBase-input MuiOutlinedInput-input"
            id="last-name"
            required=""
            type="text"
            value="Test last"
          />
          <fieldset
            aria-hidden="true"
            class="PrivateNotchedOutline-root-3 MuiOutlinedInput-notchedOutline"
          >
            <legend
              class="PrivateNotchedOutline-legendLabelled-5 PrivateNotchedOutline-legendNotched-6"
            >
              <span>
                Last name
                 *
              </span>
            </legend>
          </fieldset>
        </div>
        
      </div>
    </div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <div
        class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
      >
        <label
          class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled Mui-required Mui-required"
          data-shrink="true"
          for="email-address"
          id="email-address-label"
        >
          Email address
          <span
            aria-hidden="true"
            class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
          >
             
            *
          </span>
        </label>
        <div
          class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
        >
          <input
            aria-invalid="false"
            class="MuiInputBase-input MuiOutlinedInput-input"
            id="email-address"
            required=""
            type="text"
            value="test@test.ca"
          />
          <fieldset
            aria-hidden="true"
            class="PrivateNotchedOutline-root-3 MuiOutlinedInput-notchedOutline"
          >
            <legend
              class="PrivateNotchedOutline-legendLabelled-5 PrivateNotchedOutline-legendNotched-6"
            >
              <span>
                Email address
                 *
              </span>
            </legend>
          </fieldset>
        </div>
        
      </div>
    </div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <div>
        <div
          class="MuiFormControl-root MuiFormControl-fullWidth"
        >
          <label
            class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
            data-shrink="false"
            for="password"
          >
            Password
            <span
              aria-hidden="true"
              class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
            >
               
              *
            </span>
          </label>
          <div
            class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd"
            required=""
          >
            <input
              aria-invalid="false"
              class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedEnd MuiOutlinedInput-inputAdornedEnd"
              id="password"
              required=""
              type="password"
              value=""
            />
            <div
              class="MuiInputAdornment-root MuiInputAdornment-positionEnd"
            >
              <button
                aria-label="toggle password visibility"
                class="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd"
                tabindex="0"
                type="button"
              >
                <span
                  class="MuiIconButton-label"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                    />
                  </svg>
                </span>
                <span
                  class="MuiTouchRipple-root"
                />
              </button>
            </div>
            <fieldset
              aria-hidden="true"
              class="PrivateNotchedOutline-root-3 MuiOutlinedInput-notchedOutline"
            >
              <legend
                class="PrivateNotchedOutline-legendLabelled-5"
              >
                <span>
                  Password
                </span>
              </legend>
            </fieldset>
          </div>
        </div>
        
      </div>
    </div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <div
        class="MuiFormControl-root MuiFormControl-fullWidth"
      >
        <label
          class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
          data-shrink="false"
          for="password-confirmation"
        >
          Confirm password
          <span
            aria-hidden="true"
            class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
          >
             
            *
          </span>
        </label>
        <div
          class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd"
          required=""
        >
          <input
            aria-invalid="false"
            class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedEnd MuiOutlinedInput-inputAdornedEnd"
            id="password-confirmation"
            required=""
            type="password"
            value=""
          />
          <div
            class="MuiInputAdornment-root MuiInputAdornment-positionEnd"
          >
            <button
              aria-label="toggle password confirmation visibility"
              class="MuiButtonBase-root MuiIconButton-root MuiIconButton-edgeEnd"
              tabindex="0"
              type="button"
            >
              <span
                class="MuiIconButton-label"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                  />
                </svg>
              </span>
              <span
                class="MuiTouchRipple-root"
              />
            </button>
          </div>
          <fieldset
            aria-hidden="true"
            class="PrivateNotchedOutline-root-3 MuiOutlinedInput-notchedOutline"
          >
            <legend
              class="PrivateNotchedOutline-legendLabelled-5"
            >
              <span>
                Confirm password
              </span>
            </legend>
          </fieldset>
        </div>
        <p
          class="MuiFormHelperText-root MuiFormHelperText-contained"
        />
      </div>
    </div>
    <div
      class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
    >
      <p
        class="MuiTypography-root makeStyles-terms-1 MuiTypography-body1"
      >
        By entering my email above I agree to receive promotional emails from Dr. Bill. I can unsubscribe at any time. For more details, please see our
         
        <b>
          <a
            href="https://www.dr-bill.ca/privacy-policy/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Privacy Policy
          </a>
           
        </b>
        or 
        <b>
          <a
            href="https://www.dr-bill.ca/contact"
            rel="noopener noreferrer"
            target="_blank"
          >
            Contact Us
          </a>
        </b>
        .
      </p>
    </div>
    <div
      class="MuiGrid-root MuiGrid-container MuiGrid-item"
    >
      <div
        class="MuiGrid-root makeStyles-fullWidthButton-2 MuiGrid-item"
      >
        <div>
          <button
            class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled MuiButton-fullWidth Mui-disabled"
            disabled=""
            tabindex="-1"
            type="button"
          >
            <span
              class="MuiButton-label"
            >
              Continue
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</body>
`;
